import { render, staticRenderFns } from "./ProductTemplate.vue?vue&type=template&id=6025fc46"
import script from "./ProductTemplate.vue?vue&type=script&lang=js"
export * from "./ProductTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProductTemplate.vue?vue&type=style&index=0&id=6025fc46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports